/* lua.js generated code 0.3.0 */

/* 
Copyright (c) 2011-2014 chukong-inc.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

 */
var Node = cc.Node
Node.prototype.add = function (child, zorder, tag) {
    var self = this
    if (tag) {
        self.addChild(child, zorder, tag)
    } else if (zorder) {
        self.addChild(child, zorder)
    } else {
        self.addChild(child)
    }
    return self
}
Node.prototype.addTo = function (parent, zorder, tag) {
    var self = this
    if (tag) {
        parent.addChild(self, zorder, tag)
    } else if (zorder) {
        parent.addChild(self, zorder)
    } else {
        parent.addChild(self)
    }
    return self
}
Node.prototype.removeSelf = function () {
    var self = this
    self.removeFromParent()
    return self
}
Node.prototype.align = function (anchorPoint, x, y) {
    var self = this
    self.setAnchorPoint(anchorPoint)
    // WARN: maybe multi result
    return self.move(x, y)
}
Node.prototype.show = function () {
    var self = this
    self.setVisible(true)
    return self
}
Node.prototype.hide = function () {
    var self = this
    self.setVisible(false)
    return self
}
Node.prototype.move = function (x, y) {
    var self = this
    if (y) {
        self.setPosition(x, y)
    } else {
        self.setPosition(x)
    }
    return self
}
Node.prototype.moveTo = function (args) {
    var self = this
    transition.moveTo(self, args)
    return self
}
Node.prototype.moveBy = function (args) {
    var self = this
    transition.moveBy(self, args)
    return self
}
Node.prototype.fadeIn = function (args) {
    var self = this
    transition.fadeIn(self, args)
    return self
}
Node.prototype.fadeOut = function (args) {
    var self = this
    transition.fadeOut(self, args)
    return self
}
Node.prototype.fadeTo = function (args) {
    var self = this
    transition.fadeTo(self, args)
    return self
}
Node.prototype.rotate = function (rotation) {
    var self = this
    self.setRotation(rotation)
    return self
}
Node.prototype.rotateTo = function (args) {
    var self = this
    transition.rotateTo(self, args)
    return self
}
Node.prototype.rotateBy = function (args) {
    var self = this
    transition.rotateBy(self, args)
    return self
}
Node.prototype.scaleTo = function (args) {
    var self = this
    transition.scaleTo(self, args)
    return self
}
// FIXME: scheduleUpdate
Node.prototype.onUpdate = function (callback) {
    var self = this
    self.update = function(dt) {
        Node.prototype.update.call(self, dt)
        callback(dt)
    }    
    self.scheduleUpdateWithPriority(0)
    return self
}
// Node.prototype.scheduleUpdate = Node.prototype.onUpdate

Node.prototype.onNodeEvent = function (eventName, callback) {
    var self = this
    if ("enter" === eventName) {
        self.onEnterCallback_ = callback
    } else if ("exit" === eventName) {
        self.onExitCallback_ = callback
    } else if ("enterTransitionFinish" === eventName) {
        self.onEnterTransitionFinishCallback_ = callback
    } else if ("exitTransitionStart" === eventName) {
        self.onExitTransitionStartCallback_ = callback
    } else if ("cleanup" === eventName) {
        self.onCleanupCallback_ = callback
    }
    self.enableNodeEvents()
}
Node.prototype.enableNodeEvents = function () {
    var self = this
    // if (self.isNodeEventEnabled_) {
    //     return self
    // }
    // self.registerScriptHandler(function (state) {
    //     if (state === "enter") {
    //         self.onEnter_()
    //     } else if (state === "exit") {
    //         self.onExit_()
    //     } else if (state === "enterTransitionFinish") {
    //         self.onEnterTransitionFinish_()
    //     } else if (state === "exitTransitionStart") {
    //         self.onExitTransitionStart_()
    //     } else if (state === "cleanup") {
    //         self.onCleanup_()
    //     }
    // })
    // self.isNodeEventEnabled_ = true
    return self
}
Node.prototype.disableNodeEvents = function () {
    var self = this
    self.unregisterScriptHandler()
    self.isNodeEventEnabled_ = false
    return self
}
// Node.prototype.onEnter = function () { }
// Node.prototype.onExit = function () { }
Node.prototype.onEnterTransitionFinish = function () { }
Node.prototype.onExitTransitionStart = function () { }
Node.prototype.onCleanup = function () { }
Node.prototype.onEnter_ = function () {
    var self = this
    self.onEnter()
    if (!self.onEnterCallback_) {
        return 
    }
    self.onEnterCallback_()
}
Node.prototype.onExit_ = function () {
    var self = this
    self.onExit()
    if (!self.onExitCallback_) {
        return 
    }
    self.onExitCallback_()
}
Node.prototype.onEnterTransitionFinish_ = function () {
    var self = this
    self.onEnterTransitionFinish()
    if (!self.onEnterTransitionFinishCallback_) {
        return 
    }
    self.onEnterTransitionFinishCallback_()
}
Node.prototype.onExitTransitionStart_ = function () {
    var self = this
    self.onExitTransitionStart()
    if (!self.onExitTransitionStartCallback_) {
        return 
    }
    self.onExitTransitionStartCallback_()
}
Node.prototype.onCleanup_ = function () {
    var self = this
    self.onCleanup()
    if (!self.onCleanupCallback_) {
        return 
    }
    self.onCleanupCallback_()
}

let orgSetCascadeOpacityEnabled = Node.prototype.setCascadeOpacityEnabled;
Node.prototype.setCascadeOpacityEnabled = function(value, recursive = false) {
    let self = this;

    orgSetCascadeOpacityEnabled.call(self, value);
    if (recursive) {
        self.getChildren().forEach(child=> {
            child.setCascadeOpacityEnabled(value, true);
        });
    }
}

Node.prototype._body = null
// Node.prototype.setPhysicsBody = Node.prototype.setPhysicsBody || cc.PhysicsSprite.prototype.setBody
// Node.prototype.getPhysicsBody = Node.prototype.getPhysicsBody || cc.PhysicsSprite.prototype.getBody